import React from 'react';
import styled from 'styled-components';
import { mediaQueries } from 'styles/utils/mediaQueries';

function HasMoreComponent({ hasMore }) {
  return <Root>+{hasMore}</Root>;
}

export default HasMoreComponent;

const Root = styled.div`
  padding: 8px;
  margin-top: 12px;
  font-size: 1.4em;
  min-width: 50px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => `${theme.colors.text.light}`};
  background: ${({ theme }) => `${theme.colors.primary.light}`};
  border-radius: 4px;
  border: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};

  ${mediaQueries.fromAndBelow.desktop`
		 max-width: 50px;
  `}
`;
